import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { ApplicantsTableDefinitionZod } from '../tables';

type Arguments = {
    applicantId: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetApplicant = ApplicantsTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetApplicant = z.infer<typeof schemaLoanRequestResolver_GetApplicant>;

export type LoanRequestResolver_GetApplicant = Resolver<Arguments, SchemaLoanRequestResolver_GetApplicant>;
